import i18n from 'shared/lib/i18n';

import {
  IP_CREATE_REQUESTED,
  IP_DELETE_REQUESTED,
  IP_DELETE_SUCCEEDED,
  IP_LIST_REQUESTED,
} from '../../actionConstants';

import apiClient from '../../apiClient';
import { history } from '../../store';

export const loadIPList = (dispatch, queryParams) => {
  dispatch({
    type: IP_LIST_REQUESTED,
    payload: apiClient.ip.all(queryParams),
  });
};

export const deleteIP = (dispatch, ipId) => {
  dispatch({
    type: IP_DELETE_REQUESTED,
    payload: apiClient.ip.delete(ipId),
    successMessage: i18n.t('ipManagement.deleteSuccess'),
    callback: () => {
      dispatch({
        type: IP_DELETE_SUCCEEDED,
        id: ipId,
      });
    },
  });
};
export const onSubmit = (dispatch, data) => {
  dispatch({
    type: IP_CREATE_REQUESTED,
    payload: apiClient.ip.create(data),
    isForm: true,
    successMessage: i18n.t('ipManagement.addSuccess'),
    callback: () => {
      history.push(`/ip-management`);
    },
  });
};
